import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthScreen } from "@/components/auth/auth-screen";
import { meApi } from "@/lib/api/me";
import { setMeSession } from "@/lib/auth/storage";
import { normalizePersonCategories } from "@/lib/types";
import { ApiError } from "@/lib/api/client";

export default function MeLoginPage() {
  const navigate = useNavigate();
  const [phone, setPhone] = useState("");
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await meApi.login(phone.trim(), pin.trim());
      setMeSession({
        person_id: res.person_id,
        name: res.name,
        phone: res.phone,
        device_pin: res.device_pin,
        person_categories: normalizePersonCategories(res.person_categories),
      });
      navigate("/me");
    } catch (err) {
      setError(
        err instanceof ApiError
          ? err.message
          : "Phone or PIN did not match. Try again."
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthScreen
      title="Devotee sign in"
      description="Use the phone number and PIN from your attendance device."
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="phone">Phone</Label>
          <Input
            id="phone"
            type="tel"
            inputMode="tel"
            autoComplete="tel"
            placeholder="10-digit mobile"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
            className="h-12 text-base"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="pin">PIN</Label>
          <Input
            id="pin"
            type="password"
            inputMode="numeric"
            autoComplete="off"
            placeholder="PIN"
            value={pin}
            onChange={(e) => setPin(e.target.value)}
            required
            className="h-12 text-base tracking-widest"
          />
        </div>
        {error && (
          <p className="text-sm text-red-600" role="alert">
            {error}
          </p>
        )}
        <Button type="submit" className="h-12 w-full text-base" size="lg" disabled={loading}>
          {loading ? "Signing in…" : "Sign in"}
        </Button>
      </form>
    </AuthScreen>
  );
}
